import React, { useState } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { useNavigate } from "react-router-dom";

import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  Link,
  Text,
  MessageBar,
  Image,
  Input,
  Field,
  Button,
} from "@fluentui/react-components";
import { ArrowLeftRegular, PersonKeyRegular } from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";

var emailRegEx = /\S+@\S+\.\S+/;

function ForgotPassword(props: any) {
  const navigate = useNavigate();

  const [emailValid, setEmailValid] = useState(false);
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentView, setCurrentView] = useState(1);

  const CheckValidEMail = (value: string): string => {
    if (emailRegEx.test(value)) {
      setEmailValid(true);
      return "";
    } else {
      setEmailValid(false);
      return i18n.t<string>("enterValidEMail");
    }
  };

  const FormValidation = (): void => {
    fetchWrapper
      .post(`${baseUrl}/api/account/forgotpassword`, { Email: email })
      .then(() => {
        setCurrentView(2);
      })
      .catch((error: any) => {
        setErrorMessage(error);
      });
  };

  const windowSize = useWindowSize();

  return (
    <div>
      <div className="blockContainerContentCentered">
        <div
          style={{
            borderRadius: "11px",
            backgroundColor: "white",
            boxShadow: "0px 6px 12px 5px silver",
            minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
            maxWidth: 500,
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            marginBottom: 20,
            animationDuration: "4s",
          }}
        >
          {currentView == 1 && (
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                <Link
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <Image
                    alt=""
                    src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                    height={50}
                  />
                </Link>
              </div>
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <form
                  onSubmit={() => {
                    FormValidation();
                  }}
                >
                  <StackShim verticalAlign="stretch" horizontal>
                    <Button
                      style={{ marginBottom: "0px" }}
                      appearance="transparent"
                      icon={<ArrowLeftRegular />}
                      onClick={() => navigate("/account/login")}
                    />
                    <h3
                      style={{ marginBottom: "0px" }}
                      /* className="lueb-MarginTopBottom10" */
                    >
                      {i18n.t<string>("resetPassword")}
                    </h3>
                  </StackShim>
                  <div className="lueb-MarginTopBottom10">
                    <Text>{i18n.t<string>("resetPasswordText")}</Text>
                  </div>
                  <Field>
                    <Input
                      placeholder="E-Mail"
                      onChange={(ev, newText) => {
                        CheckValidEMail(newText ? newText.value : "");
                        setEmail(newText ? newText.value : "");
                      }}
                      appearance="underline"
                      value={email}
                      /* className="lueb-MarginBottom20" */
                    />
                  </Field>

                  {!emailValid && (
                    <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                      <MessageBar intent={"error"}>
                        {i18n.t<string>("enterValidEMail")}
                      </MessageBar>
                    </div>
                  )}

                  {errorMessage != "" && (
                    <MessageBar intent={"error"}>
                      {i18n.t<string>(errorMessage)}
                    </MessageBar>
                  )}

                  <div className="lueb-padding5 lueb-MarginTopBottom10 lueb-floatRight">
                    <Button
                      appearance="primary"
                      disabled={!emailValid}
                      icon={<PersonKeyRegular />}
                      onClick={() => FormValidation()}
                    >
                      {i18n.t<string>("resetPassword")}
                    </Button>
                    {/* <PrimaryButton
                      iconProps={{ iconName: "Signin" }}
                    ></PrimaryButton> */}
                  </div>
                </form>
              </div>
            </div>
          )}
          {currentView == 2 && (
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Link onClick={() => navigate("/")}>
                  <Image
                    src={
                      "static/media/LUEBBERING_DIGITAL_SVG_LOGO_LONG.1fb3141f971dba37cc76e10eaa69416a.svg"
                    }
                    height={50}
                    className="lueb-MarginBottom30"
                  />
                </Link>
              </div>
              <StackShim horizontal>
                <h3
                  style={{ marginBottom: "0px" }}
                  className="lueb-MarginTopBottom10"
                >
                  {i18n.t<string>("resetPassword")}
                </h3>
              </StackShim>
              <div className="lueb-MarginTopBottom10">
                {i18n
                  .t("resetPasswordSuccessfulText")
                  .split("\n")
                  .map((item) => {
                    return (
                      <div className="lueb-MarginTopBottom10">
                        <Text>{item}</Text>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
